// src/pages/Users/Techniques/components/SkeletonCard.jsx
import React from "react";

export default function SkeletonCard() {
  return (
    <div className="rounded-2xl overflow-hidden ring-1 ring-slate-200 dark:ring-slate-800 bg-white/70 dark:bg-slate-900/50 animate-pulse">
      <div className="w-full bg-slate-200 dark:bg-slate-800" style={{ aspectRatio: "551 / 617" }} />
      <div className="p-3 space-y-2">
        <div className="h-4 w-24 bg-slate-200 dark:bg-slate-800 rounded" />
        <div className="h-4 w-3/4 bg-slate-200 dark:bg-slate-800 rounded" />
        <div className="h-3 w-1/2 bg-slate-200 dark:bg-slate-800 rounded" />
      </div>
    </div>
  );
}
